export default "__VITE_ASSET__3a51b22c__"